<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate';
import {
  BModal,
  BButton,
  BAlert,
  BRow,
  BCol,
  BFormGroup,
  BFormCheckbox,
  AlertPlugin,
  BTable,
  BMedia,
  BForm,
  BAvatar,
  BFormInput,
  BOverlay,
} from 'bootstrap-vue';
import vSelect from 'vue-select';
import { ref } from '@vue/composition-api';
import { avatarText } from '@core/utils/filter';
import axios from '@/libs/axios';
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue';

export default {
  components: {
    BFormInput,
    BAvatar,
    BForm,
    BMedia,
    BTable,
    BModal,
    BButton,
    BAlert,
    vSelect,
    BRow,
    BCol,
    BFormGroup,
    BFormCheckbox,
    ValidationProvider,
    ValidationObserver,
    BOverlay,
  },
  props: {
    value: {
      type: Object,
      default: () => ({
        usuarioid: '',
        usuario_nome: '',
        usuario_senha: '',
      }),
      require: true,
    },

  },
  data() {
    return {
      senhaAtual: '',
      desabilitarSenha: true,
      isLoading: false,
      adminNovaSenha: '',
      adminConfirmacaoNovaSenha: '',
      adminResetSenhaExecutado: false,
    };
  },
  computed: {
    dataForm: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
    usuarioAtivo: {
      get() {
        return this.dataForm.usuario_ativo === 1;
      },
      set(value) {
        this.dataForm.usuario_ativo = value ? 1 : 0;
      },
    },
    isAdminResetSenha() {
      const usuarioLogado = JSON.parse(localStorage.getItem('userData')) || null;
      let perfis = [];

      if (usuarioLogado?.perfils) {
        perfis = usuarioLogado.perfils;
      } else if (usuarioLogado?.userData?.perfils) {
        perfis = usuarioLogado.userData.perfils;
      }

      return perfis.some((perfil) => (
        perfil?.perfil_acesso_nome === 'AdminDKP'
        || perfil?.perfil_acesso_nome === 'AdminHanes'
        || perfil?.perfil_acesso_nome === 'Adm.Vendas'
      ));
    },
  },
  methods: {
    async onSubmit(dataform) {
      // Validar o formulário antes de enviar
      const isValid = await this.$refs.refFormData.validate();
      if (!isValid) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Atenção',
            text: 'Verifique os campos do formulário',
            icon: 'AlertTriangleIcon',
            variant: 'warning',
          },
        });
        return;
      }

      this.isLoading = true;
      try {
        const payload = { ...dataform };

        if (this.desabilitarSenha || this.adminResetSenhaExecutado) {
          delete payload.novaSenha;
        }

        if (!payload.novaSenha) {
          delete payload.novaSenha;
        }

        if (!payload.usuario_senha) {
          delete payload.usuario_senha;
        }

        // Não enviar senha antiga se foi feito reset administrativo
        if (this.adminResetSenhaExecutado) {
          delete payload.usuario_senha;
        }

        await axios.put('/usuarios/update/', payload);
        // this.$bvModal.hide('modal-att-usuario')
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Sucesso',
            text: 'Dados Atualizados',
            icon: 'CheckIcon',
            variant: 'success',
          },
        });
        // location.reload();
      } catch (error) {
        console.error('Erro ao chamar a API:', error);
      } finally {
        this.isLoading = false;
      }
    },
    async verificarSenha() {
      console.log('Senha Atual', this.dataForm.usuario_senha);
      console.log('Senha Digitada', this.senhaAtual);

      this.isLoading = true;
      try {
        const response = await axios.post('/auth/verificaSenha', {
          senhaDigitada: this.senhaAtual,
          usuario_senha: this.dataForm.usuario_senha,
        });

        if (response.data.message === false) {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'Erro',
              text: 'Senha Atual Incorreta',
              icon: 'XCircleIcon',
              variant: 'danger',
            },
          });
        } else {
          this.desabilitarSenha = false;
          this.dataForm.usuario_senha = '';
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'Sucesso',
              text: 'Senha Atual Correta',
              icon: 'CheckIcon',
              variant: 'success',
            },
          });
        }
      } catch (error) {
        console.error('Erro ao chamar a API:', error);
      } finally {
        this.isLoading = false;
      }
    },
    async resetSenhaAdmin() {
      if (!this.dataForm?.usuario_email) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Atenção',
            text: 'E-mail do usuário não informado',
            icon: 'AlertTriangleIcon',
            variant: 'warning',
          },
        });
        return;
      }

      if (!this.adminNovaSenha || !this.adminConfirmacaoNovaSenha) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Atenção',
            text: 'Informe a nova senha e a confirmação',
            icon: 'AlertTriangleIcon',
            variant: 'warning',
          },
        });
        return;
      }

      if (this.adminNovaSenha !== this.adminConfirmacaoNovaSenha) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Atenção',
            text: 'A confirmação não confere com a nova senha',
            icon: 'AlertTriangleIcon',
            variant: 'warning',
          },
        });
        return;
      }

      this.isLoading = true;
      try {
        await axios.post('/seguranca/resetSenhaAdmin', {
          email: this.dataForm.usuario_email,
          novaSenha: this.adminNovaSenha,
          confirmacaoNovaSenha: this.adminConfirmacaoNovaSenha,
        });

        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Sucesso',
            text: 'Senha do usuário alterada com sucesso',
            icon: 'CheckIcon',
            variant: 'success',
          },
        });

        this.adminNovaSenha = '';
        this.adminConfirmacaoNovaSenha = '';
        this.adminResetSenhaExecutado = true;
        this.dataForm.novaSenha = '';
        this.dataForm.usuario_senha = '';
        this.senhaAtual = '';
        this.desabilitarSenha = true;
      } catch (error) {
        console.error('Erro ao resetar senha:', error);
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Erro',
            text: 'Falha ao alterar a senha do usuário',
            icon: 'AlertTriangleIcon',
            variant: 'danger',
          },
        });
      } finally {
        this.isLoading = false;
      }
    },
  },
  setup() {
    const statusOptions = [
      { label: 'Ativo', value: 1 },
      { label: 'Inativo', value: 0 },
    ];
    return {
      // Filter
      avatarText,
      statusOptions,
    };
  },
};
</script>

<template>
  <b-overlay :show="isLoading" rounded="sm">
    <validation-observer ref="refFormData">
      <div>
        <b-form @submit.prevent class="user-form">

        <!-- BLOCO: DADOS DO USUÁRIO -->
        <b-card class="mb-2" body-class="p-2">
          <h6 class="mb-1 text-primary">Dados do Usuário</h6>

          <b-row>
            <b-col cols="12" md="6">
              <b-form-group label="Nome">
                <b-form-input v-model="dataForm.usuario_nome"/>
              </b-form-group>
            </b-col>

            <b-col cols="12" md="6">
              <validation-provider name="Email" rules="required|email" #default="{ errors }">
                <b-form-group label="Email">
                  <b-form-input v-model="dataForm.usuario_email"/>
                  <b-form-invalid-feedback v-if="errors.length">
                    {{ errors[0] }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </validation-provider>
            </b-col>

            <b-col cols="12" md="6">
              <b-form-group label="Status">
                <b-form-checkbox v-model="usuarioAtivo">
                  Usuário ativo
                </b-form-checkbox>
              </b-form-group>
            </b-col>

            <b-col cols="12" md="6">
              <b-form-group label="Autenticação Integrada (Active Directory)">
                <b-form-checkbox v-model="dataForm.usuario_autentica_ad">
                  Usar Active Directory
                </b-form-checkbox>
              </b-form-group>
            </b-col>
          </b-row>
        </b-card>

        <!-- BLOCO: SENHA DO USUÁRIO -->
        <b-card class="mb-2" body-class="p-2">
          <h6 class="mb-1 text-primary">Alteração de Senha</h6>

          <b-row>
            <b-col cols="12" md="6">
              <b-form-group label="Senha Atual">
                <b-form-input
                  type="password"
                  v-model="senhaAtual"
                  @blur="verificarSenha()"
                />
              </b-form-group>
            </b-col>

            <b-col cols="12" md="6">
              <b-form-group label="Nova Senha">
                <b-form-input
                  type="password"
                  v-model="dataForm.novaSenha"
                  :disabled="desabilitarSenha"
                />
              </b-form-group>
            </b-col>
          </b-row>

          <b-alert variant="secondary" show class="mb-0">
            <feather-icon icon="InfoIcon" class="mr-50"/>
            Informe sua senha atual para liberar a nova senha.
          </b-alert>
        </b-card>

        <!-- BLOCO: ADMIN -->
        <b-card v-if="isAdminResetSenha" class="mb-2 border-primary" body-class="p-2">
          <h6 class="mb-1 text-primary">Reset Administrativo</h6>

          <b-alert variant="primary" show>
            <feather-icon icon="ShieldIcon" class="mr-50"/>
            Administradores podem redefinir a senha deste usuário.
          </b-alert>

          <b-row>
            <b-col cols="12" md="6">
              <b-form-group label="Nova Senha (Admin)">
                <b-form-input v-model="adminNovaSenha" type="password"/>
              </b-form-group>
            </b-col>

            <b-col cols="12" md="6">
              <b-form-group label="Confirmação">
                <b-form-input v-model="adminConfirmacaoNovaSenha" type="password"/>
              </b-form-group>
            </b-col>
          </b-row>
        </b-card>

      </b-form>
      </div>
      <div class="mt-2">
        <b-button
            variant="primary"
            class="mb-1 mb-sm-0 mr-0 mr-sm-1"
            :disabled="isLoading || dataForm.isDefault || dataForm.usuario_nome === ''"
            @click="onSubmit(dataForm)"
        >
          Salvar Alterações
        </b-button>
        <b-button
            v-if="isAdminResetSenha"
            variant="warning"
            class="mb-1 mb-sm-0"
            :disabled="isLoading"
            @click="resetSenhaAdmin"
        >
          Resetar Senha (Admin)
        </b-button>
      </div>
    </validation-observer>
  </b-overlay>
</template>

<style scoped>
.user-form .form-group {
  margin-bottom: 1.2rem;
}

.user-form h6 {
  font-weight: 600;
  border-bottom: 1px solid rgba(0,0,0,.05);
  padding-bottom: .4rem;
}
</style>
